exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -ms-flex-line-pack: stretch;\n      align-content: stretch;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.label-icon .icon {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.label-icon .text {\n  width: calc(24%);\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  margin-left: 12px;\n}\n.label-icon .text .title {\n  font-size: 15px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.label-icon .text .subtitle {\n  font-size: 11px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.label-icon .text.protected {\n  color: #9c9c9c;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/label-icon/label-icon.component.less
// module id = 1398
// module chunks = 2